"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFromRecordFieldOrNothing = exports.WeekMs = exports.DayMs = exports.HourMs = exports.MinuteMs = exports.SecondMs = void 0;
var constants_iso_1 = require("@wranggle/constants-iso");
Object.defineProperty(exports, "SecondMs", { enumerable: true, get: function () { return constants_iso_1.SecondMs; } });
Object.defineProperty(exports, "MinuteMs", { enumerable: true, get: function () { return constants_iso_1.MinuteMs; } });
Object.defineProperty(exports, "HourMs", { enumerable: true, get: function () { return constants_iso_1.HourMs; } });
Object.defineProperty(exports, "DayMs", { enumerable: true, get: function () { return constants_iso_1.DayMs; } });
Object.defineProperty(exports, "WeekMs", { enumerable: true, get: function () { return constants_iso_1.WeekMs; } });
function dateFromRecordFieldOrNothing(val) {
    if (!val) {
        return;
    }
    try {
        return new Date(val);
    }
    catch (err) {
        return undefined;
    }
}
exports.dateFromRecordFieldOrNothing = dateFromRecordFieldOrNothing;
//# sourceMappingURL=time-and-date-util.js.map